import RECEIPT_TEMPLATE from "@/assets/images/receipt-template-18th";
import REGIONS from "@/assets/tables/regions.json";
import RECEIPT_TYPES from "@/assets/tables/receipt_types.json";
import BIG_NUMBER_TW from "@/assets/tables/big_number_tw.json";

export default receipts => {
  return doc => {
    receipts.forEach((item, i) => {
      if (i > 0) doc.addPage();

      const { receipt, payer } = item;
      const { serialNumber, session } = receipt;
      const settleTime = receipt.settleTime.toDate();
      const year = settleTime.getFullYear() - 1911;
      const month = settleTime.getMonth() + 1;
      const date = settleTime.getDate();
      const { displayName } = payer;
      const region = REGIONS[payer.region].text;
      const jobs = payer.jobs ? payer.jobs.join("、") : "";
      const items = receipt.items.map(item => {
        const type = RECEIPT_TYPES[item.type].text;
        const payment = item.payment.toLocaleString();
        let remarks = `${item.year} 年度`;
        if (item.type === "donation") remarks += ` ${item.donation || ""}`;
        if (item.type === "other") remarks += ` ${item.other || ""}`;
        return { type, payment, remarks };
      });
      const payee = receipt.payee.displayName;
      let gender = payer.gender;

      switch (gender) {
        case "male":
          gender = "先生";
          break;
        case "female":
          gender = "女士";
          break;
        default:
          gender = "";
      }

      const center = { align: "center" };
      const right = { align: "right" };

      const drawItemList = items.reduce((acc, item, index) => {
        const rowHeight = 70 + 10 * index;
        const remarksRowHeight = 70 + 10 * index;
        acc.push([item.type, 18, rowHeight]);
        acc.push([item.payment, 128, rowHeight, right]);
        acc.push([item.remarks, 140, remarksRowHeight, { baseline: top }]);
        return acc;
      }, []);

      const total = String(receipt.total);
      const totalLen = total.length;
      const drawTotalList = [];
      const baseX = 139;
      const baseY = 120;

      for (let i = 0, l = totalLen; i < l; i += 1) {
        const v = total[i];
        const offsetX = baseX + -19 * (totalLen - i - 1);
        const text = BIG_NUMBER_TW[v];
        drawTotalList.push([text, offsetX, baseY, center]);
      }

      const { zipCode = "", address = "" } = payer;

      const drawMailList = [
        [zipCode, 20, 166, { align: "left" }, 10],
        [address, 20, 173, { align: "left" }, 14],
        [`${displayName}  ${gender}  鈞啟`, 20, 184, { align: "left" }, 14]
      ];

      const drawList = [
        [year, 98, 39, center],
        [month, 111, 39, center],
        [date, 125, 39, center],
        [`${displayName}  ${gender}`, 30, 49],
        [region, 90, 49],
        [jobs, 150, 49],
        [payee, 178, 132, { align: "left" }],
        [serialNumber, 160, 19]
      ]
        .concat(drawItemList, drawTotalList, drawMailList)
        .map(item => {
          if (["string", "number"].indexOf(typeof item[0]) !== -1)
            item[0] = String(item[0]);
          return item;
        });

      //
      const W = 210;
      const H = 297;

      const receiptTemplate = RECEIPT_TEMPLATE;

      doc.addImage(receiptTemplate, "JPEG", 0, 0, W, H);

      drawList.forEach(item => {
        if (item[4]) {
          doc.setFontSize(item[4]);
        } else {
          doc.setFontSize(12);
        }

        doc.text(item[0], item[1], item[2], item[3]);
      });

      // tatal delete line
      if (totalLen < 6) {
        doc.line(40, 118, 40 + 19 * (6 - totalLen), 118);
      }
    });
  };
};
